<template>
  <div class="app-container">
    <section class="base-page container">
      <el-carousel class="banner-container" v-if="lunboImgs.length>0">
        <el-carousel-item v-for="item in lunboImgs" :key="item.id">
          <a @click="ifcontent(item.content,item.id)">
            <img :src="item.picture" alt="" class="bannerimg">
          </a>
        </el-carousel-item>
      </el-carousel>
      <div class="platform">
        <div class="subtitle">关于平台</div>
        <div class="linediv"></div>
        <el-row>
          <el-col :span="10" style="text-align: right;">
            <img :src="platimg" class="imgabo">
          </el-col>
          <el-col :span="8">
            <div class="textdiv">
              <span class="abospan">{{aboPlat}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="cooperation" v-if="plans.length>0">
        <div class="subtitle">合作方案</div>
        <div class="linediv"></div>
        <div class="carousediv">
          <el-carousel arrow="always">
            <el-carousel-item v-for="item in plans" :key="item.id">
              <div class="carddiv">
                <el-card>
                  <el-col :span="12">
                    <img :src="item.picture" alt="" class="planimgs">
                  </el-col>
                  <el-col :span="12">
                    <div class="rightCard">
                      <span class="title" ref="subhead_title">{{item.title}}</span>
                      <p class="content" ref="subhead_content">{{item.subhead | ellipsis}}</p>
                      <el-button class="btn" @click="plandetail(item.id)" round>查看详情<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                    </div>
                  </el-col>
                </el-card>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="process">
        <div class="subtitle">合作流程</div>
        <div class="linediv"></div>
        <div class="pros">
          <div class="steps">
            <img :src="creatorimg" alt="">
            <div>01、成为开发者</div>
          </div>
          <div class="stepout">
            <div class="stepline"></div>
          </div>
          <div class="steps">
            <img :src="creatimg" alt="">
            <div>02、创建产品</div>
          </div>
          <div class="stepout">
            <div class="stepline"></div>
          </div>
          <div class="steps">
            <img :src="develimg" alt="">
            <div>03、研发产品</div>
          </div>
          <div class="stepout">
            <div class="stepline"></div>
          </div>
          <div class="steps">
            <img :src="releaseimg" alt="">
            <div>04、发布产品</div>
          </div>
        </div>
        <div>
          <el-button round class="btn" @click="openIoT">立即前往T-Smart物联网平台</el-button>
        </div>
      </div>
      <div class="partners" v-if="allpartners.length>0">
        <div class="subtitle">合作伙伴</div>
        <div class="linediv"></div>
        <div class="carouseldiv">
          <el-carousel indicator-position="none">
            <el-carousel-item v-for="(item,ind) in partnerlist" :key="ind">
              <div class="partout">
                <el-row>
                  <el-col :span="4" v-for="(o, index) in item" :key="index" :offset="1" style="margin:0 22px 24px 0">
                    <el-card class="partcard">
                      <img :src="o.logo" v-if="o.logo">
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <footBar></footBar>
    </section>
  </div>
</template>
<script>
import footBar from '@/components/footbar'
import { bannerlist, planlist, partnerlist } from '@/services/api/index'
import platImg from '@/assets/images/aboutplatform_pic.png'
import creatorImg from '@/assets/images/cooperationprocess_icon01.png'
import creatImg from '@/assets/images/cooperationprocess_icon02.png'
import develImg from '@/assets/images/cooperationprocess_icon03.png'
import releaseImg from '@/assets/images/cooperationprocess_icon04.png'
export default {
  name: 'productList',
  computed: {
  },
  watch: {

  },
  components: {
    footBar
  },
  data() {
    return {
      loading: false,
      lunboImgs: [],
      plans: [],
      platimg: platImg,
      aboPlat: 'T-Smart物联网平台是拓邦依托全球的智能控制技术优势和产业经验，为企业提供从控制器到云端服务、从需求到产品量产的 一站式智能化服务平台，帮助客户快速、稳定、高品质地完成产品智能化，满足大批量出货需求。',
      creatorimg: creatorImg,
      creatimg: creatImg,
      develimg: develImg,
      releaseimg: releaseImg,
      allpartners: [],
      partnerlist: [],
    }
  },
  filters: {
    ellipsis(value) {
      if (!value) return '';
      // if (value.length > 80) {
      //   return value.slice(0, 80) + '...'
      // }
      return value
    }
  },
  methods: {
    goUrl(url) {
      this.$router.push({ path: url })
    },
    openIoT() {
      let path = process.env.VUE_APP_PRODUCT_URL_NAME
      location.href = path
      // window.open(path, "_blank")
    },
    initPages() {
      this.getbanners();
      this.getplans();
      this.getpartners()
    },
    getbanners() {
      bannerlist().then(res => {
        this.lunboImgs = res && res.data.Banners ? res.data.Banners : []
      })
    },
    getplans() {
      planlist().then(res => {
        this.plans = res && res.data.CooperationProgrammes ? res.data.CooperationProgrammes : []
        setTimeout(() => {
          this.setText()
        }, 500)
      })
    },
    getpartners() {
      partnerlist().then(res => {
        this.allpartners = res.data.partners
        var k = 0;
        var m = Math.ceil(res.data.total / 10)
        // console.log(m)    
        var arr = new Array();
        for (var i = 0; i < m; i++) {
          arr[i] = new Array();
          for (var j = 0; j < 10 && k < res.data.total; j++) {
            arr[i][j] = res.data.partners[k++]
          }
        }
        this.partnerlist = arr
        console.log(this.partnerlist)
      })
    },
    ifcontent(data, id) {
      if (!data) {
        return false;
      } else {
        this.goUrl(`/home/bannerdetail/${id}`)
      }
    },
    plandetail(data) {
      this.goUrl(`/home/plandetail/${data}`)
    },
    setText() {
      if (!this.isIE()) return
      console.log(this.$refs.subhead_content)
      let dom_content = this.$refs.subhead_content
      dom_content && dom_content.forEach(dom => {
        if (dom.offsetHeight > 80) {
          let len = dom.innerText.length
          let lines = dom.offsetHeight / 28
          let index = len / lines * 3
          dom.innerText = len < index ? dom.innerText : dom.innerText.substring(0, index) + '...'
        }
      })
    },
    isIE() {
      if(!!window.ActiveXObject || "ActiveXObject" in window) {
        return true
      } else {
        return false
  　　 }
    }
  },
  mounted() {
    this.initPages()
  }
}

</script>
<style rel="stylesheet/scss" lang="scss">
@import "~styles/index.scss";

.el-carousel__indicator.is-active button {
  background-color: #1cc0c9;
}
.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
  -webkit-box-shadow: 0 21px 43px 0 rgba(186, 186, 188, 0.25) !important;
  box-shadow: 0 21px 43px 0 rgba(186, 186, 188, 0.25) !important;
}
.banner-container {
  height: vw(500);
  .el-carousel__container {
    height: vw(500);
  }
  .bannerimg {
    width: 100%;
    height: vw(500);
  }
}


.subtitle {
  font-weight: 600;
  font-size: vw(28);
  text-align: center;
  margin: 0 auto;
  line-height: vw(36);
}

.platform {
  width: 100%;
  padding: vw(79) 0 vw(60);

  .imgabo {
    margin-right: vw(50);
    max-width: 80%;
  }

  .textdiv {
    padding: vw(50) 0;
    line-height: vw(36);
  }
}

.linediv {
  width: vw(49);
  height: 4px;
  background-color: #1cc0c9;
  border-radius: 2px;
  text-align: center;
  margin: 0 auto;
  margin-top: vw(10);
  margin-bottom: vw(30);
}

.cooperation {
  clear: both;
  background-image: url('../assets/images/cooperationscheme_bg.png');
  height: vw(508);
  width: 100%;
  padding-top: vw(79);
  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .carousediv {
    text-align: center;
    margin: 0 auto;
    margin-top: vw(26);
    height: vw(350);
    width: vw(1200);
    .el-carousel__container {
      height: vw(350);
    }
    .carddiv {
      padding: 0 vw(90);
    }

    .el-card {
      width: vw(1016);
      height: vw(278);

      .el-card__body {
        padding: 0;
        height: vw(278);
      }

      .planimgs {
        height: vw(278);
        width: 100%;
        /* height:282px; */
      }

      .rightCard {
        padding: vw(20);
        text-align: left;

        .title {
          font-family: MicrosoftYaHei-Bold;
          font-size: vw(18);
          font-weight: bold;
          font-stretch: normal;
          line-height: vw(20);
          letter-spacing: 0px;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          word-break: break-all;
          @include screenIE {
            white-space: nowrap;
            display: inline-block;
            width: 100%;
            position: relative;
            max-height: vw(20);
          }
        }

        .content {
          margin-top: vw(28);
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: vw(28);
          letter-spacing: 0px;
          color: #333;
          display: -webkit-box;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          word-break: break-all;
        }

        .btn {
          margin-top: vw(40);
          color: white;
          background-color: #333333;
          &:hover {
            background-color: #4d4d4d;
          }
        }
      }

    }

    .el-carousel__button {
      width: vw(10);
      height: vw(10);
      border-radius: 5px;
      background-color: #c1c1c1;
    }
    .el-carousel__arrow {
      top: 40%;
    }
    .el-carousel__indicator.is-active button {
      width: vw(25);
      height: vw(10);
      background-color: #333333;
      border-radius: 5px
    }
  }

}

.process {
  height: vw(357);
  width: 100%;
  text-align: center;
  padding-top: vw(79);

  .steps {
    height: vw(94);
    width: vw(120);
    display: inline-block;
  }

  .stepout {
    height: vw(47);
    display: inline-block;
    padding-top: 46px;

    .stepline {
      width: vw(87);
      height: 1px;
      background-color: #666666;
    }
  }

  .btn {
    margin-top: vw(52);
    color: white;
    background-color: #333;
    &:hover {
      color: white;
      background-color: #4d4d4d;
    }
  }
}

.partners {
  width: 100%;
  height: vw(431);
  padding-top: vw(79);
  background-image: url('../assets/images/cooperativepartner_bg.png');

  .carouseldiv {
    text-align: center;
    margin: 0 auto;
    margin-top: vw(53);
    width: vw(1200);
    height: vw(250);
    .el-carousel__container {
      height: vw(250);
    }
    .partout {
      padding-left: vw(90);

      .partcard {
        height: vw(96);
        width: vw(182);
        margin: 0;

        .el-card__body {
          padding: vw(10) vw(20);
        }

        img {
          width: vw(132);
          height: vw(73);
        }

        /* .imgs{
                        height:96px;
                        display: table-cell;
                        vertical-align: middle;
                    } */
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/home.vue